export default {"src":"/_next/static/media/sales_partner.eaa4ecb5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};